var _circle, _rect, _circle2, _path, _circle3, _circle4, _circle5, _circle6, _g, _g2, _g3, _g4, _line, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFleetManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 180,
    fill: "#DBEAFE",
    opacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 80,
    width: 120,
    height: 90,
    rx: 8,
    fill: "#1E293B",
    stroke: "#2563EB",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 125,
    r: 25,
    fill: "#10B981",
    opacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 200 105 L 200 125 L 215 140",
    stroke: "#10B981",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 155,
    r: 5,
    fill: "#10B981"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 155,
    r: 5,
    fill: "#EF4444"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 155,
    r: 5,
    fill: "#F59E0B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 155,
    r: 5,
    fill: "#10B981"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 60,
    height: 35,
    rx: 4,
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 10,
    width: 25,
    height: 35,
    rx: 4,
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 10 L 0 0 L 20 -10 L 30 -10 L 30 10 Z",
    fill: "#1E40AF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 48,
    r: 8,
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 48,
    r: 8,
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 48,
    r: 8,
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: -5,
    r: 8,
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72 -5 L 74 -3 L 78 -7",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(240, 200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 60,
    height: 35,
    rx: 4,
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 10,
    width: 25,
    height: 35,
    rx: 4,
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 10 L 0 0 L 20 -10 L 30 -10 L 30 10 Z",
    fill: "#1E40AF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 48,
    r: 8,
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 48,
    r: 8,
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 48,
    r: 8,
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: -5,
    r: 8,
    fill: "#F59E0B"
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: -2,
    fontSize: 10,
    fill: "#FFFFFF",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "!"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 290)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 60,
    height: 35,
    rx: 4,
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 10,
    width: 25,
    height: 35,
    rx: 4,
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 10 L 0 0 L 20 -10 L 30 -10 L 30 10 Z",
    fill: "#1E40AF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 48,
    r: 8,
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 48,
    r: 8,
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 48,
    r: 8,
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: -5,
    r: 8,
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72 -5 L 74 -3 L 78 -7",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    fill: "none"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(240, 290)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 60,
    height: 35,
    rx: 4,
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 10,
    width: 25,
    height: 35,
    rx: 4,
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 10 L 0 0 L 20 -10 L 30 -10 L 30 10 Z",
    fill: "#1E40AF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 48,
    r: 8,
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 48,
    r: 8,
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 48,
    r: 8,
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: -5,
    r: 8,
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: -2,
    fontSize: 10,
    fill: "#FFFFFF",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "X"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 170,
    x2: 110,
    y2: 210,
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeDasharray: "4 2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 170,
    x2: 270,
    y2: 210,
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeDasharray: "4 2"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 170,
    x2: 110,
    y2: 300,
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeDasharray: "4 2"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 170,
    x2: 270,
    y2: 300,
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeDasharray: "4 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetManagement);
export default __webpack_public_path__ + "static/media/fleet-management.e008d4b8c03225b5c6bd2000f9a394eb.svg";
export { ForwardRef as ReactComponent };